export const NOTIFICATION_STATUS = {
    Instantly: 'instant',
    Daily: 'daily',
    Never: 'disabled',
};
